"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const serializers_1 = require("../serializers");
const sdk_contants_1 = require("../../constants/sdk.contants");
let instance;
class AuthClient {
    static getInstance(options, retryOptions) {
        if (!instance) {
            instance = new AuthClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.AuthSerializer());
        }
        return instance;
    }
    constructor(client, authSerializer) {
        this.client = client;
        this.authSerializer = authSerializer;
    }
    async requestToken(tokenRequest, headers) {
        const response = await this.client.post(`${sdk_contants_1.ENGINE_API_PREFIX}/oauth/token`, tokenRequest, {
            headers,
        });
        return this.authSerializer.serializeOne(response.body.data);
    }
    async refreshToken(refreshTokenRequest, headers) {
        const response = await this.client.post(`${sdk_contants_1.ENGINE_API_PREFIX}/oauth/refresh-token`, refreshTokenRequest, {
            headers,
        });
        return this.authSerializer.serializeOne(response.body.data);
    }
    getToken() {
        return this.token;
    }
    setToken(value) {
        this.token = value;
    }
}
exports.AuthClient = AuthClient;
//# sourceMappingURL=auth.client.js.map